<template>
  <router-view v-slot="{ Component }">
    <keep-alive :include="store.state.cachePages">
      <component :is="Component" />
    </keep-alive>
  </router-view>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
const store = useStore();

// 兼容浏览器的100vh高度缺陷问题
function setRealHeight() {
  const el = document.querySelector('#app');
  if (el) {
    el.style.height = window.innerHeight + 'px';
  }
}

onMounted(() => {
  setRealHeight();
  window.addEventListener('resize', setRealHeight);
  window.addEventListener('orientationchange', setRealHeight);
});

onUnmounted(() => {
  window.removeEventListener('resize', setRealHeight);
  window.removeEventListener('orientationchange', setRealHeight);
});
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $text-color;
  font-size: 16px;
  line-height: 22px;
  height: 100vh;
}
</style>
